import { Box, TextButton } from '@wix/design-system'
import { ArrowLeft } from '@wix/wix-ui-icons-common/lazy'
import React, { FC } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP } from '../../../breakpoints'
import { footerControlsDataHooks as dataHooks } from './FooterControls.dataHooks'

interface FooterControlsProps {
  backOnClick?: () => void
  backText?: string
  skipOnClick?: () => void
  skipText?: string
  isLightSkip?: boolean
  dataHook?: string
  isVisible?: boolean
  spacerHeight?: FooterControlsSpacerHeight
  type?: FooterControlsType
}

export enum FooterControlsType {
  DEFAULT = 'DEFAULT',
  TRANSPARENT = 'TRANSPARENT',
}

export enum FooterControlsSpacerHeight {
  DEFAULT = 48,
  FULL = 78,
  NONE = 0,
}

export const FooterControls: FC<FooterControlsProps> = ({
  backOnClick,
  skipOnClick,
  backText,
  skipText,
  isLightSkip,
  dataHook,
  isVisible,
  type = FooterControlsType.DEFAULT,
  spacerHeight = FooterControlsSpacerHeight.DEFAULT,
}) => {
  const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)

  return (
    <>
      {/* spacer for fixed-positioned footer: */}
      {spacerHeight !== FooterControlsSpacerHeight.NONE && <Box height={`${spacerHeight}px`} />}

      {/* the footer itself: */}
      <Box
        transition="opacity .2s ease"
        pointerEvents={!isVisible ? 'none' : 'auto'}
        opacity={!isVisible ? 0 : 1}
        dataHook={dataHook}
        background={type === FooterControlsType.TRANSPARENT ? 'transparent' : 'white'}
        padding="30px 36px"
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        boxShadow={type === FooterControlsType.TRANSPARENT ? 'unset' : '0 0 6px 0 rgba(0, 0, 0, 0.12)'}
      >
        {backText && (
          <TextButton
            skin="dark"
            size={isLargeDesktopScreen ? 'medium' : 'small'}
            prefixIcon={<ArrowLeft />}
            onClick={backOnClick}
            dataHook={dataHooks.backButton()}
          >
            {backText}
          </TextButton>
        )}
        <Box margin="auto" />
        {skipText && (
          <TextButton
            skin={isLightSkip ? 'light' : 'dark'}
            size={isLargeDesktopScreen ? 'medium' : 'small'}
            onClick={skipOnClick}
            dataHook={dataHooks.skipButton()}
          >
            {skipText}
          </TextButton>
        )}
      </Box>
    </>
  )
}
